import {
  PartialScreenWithCoveragesRecord,
  ScreenWithCoverages,
} from "../../types";

enum SettlementOption {
  Acv = "Actual Cash Value",
  Rc = "Replacement Cost",
  Erc = "Extended Replacement Cost",
  Frc = "Full Repair Cost",
}

const homeCoverageSettlementTypeTooltip: Record<
  SettlementOption,
  PartialScreenWithCoveragesRecord
> = {
  [SettlementOption.Acv]: {
    [ScreenWithCoverages.PlanDetails]:
      "Actual Cash Value (ACV) refers to the cost to repair or replace your home minus depreciation. Depreciation is the reduction in value resulting from aging and deterioration. As an example, a 15 year old roof is not as valuable as a 5 year old roof.",
  },
  [SettlementOption.Rc]: {
    [ScreenWithCoverages.PlanDetails]:
      "Replacement Cost (RC) refers to the cost to repair or replace the home. No depreciation occurs.",
  },
  [SettlementOption.Erc]: {
    [ScreenWithCoverages.PlanDetails]:
      "Extended Replacement Cost (ERC) works similar to Replacement Cost. However, if a total loss occurs, ERC provides up to an additional 20% in coverage if the home costs more to replace than the purchased dwelling limit.",
  },
  [SettlementOption.Frc]: {
    [ScreenWithCoverages.PlanDetails]:
      "Full Repair Cost, sometimes referred to as Replacement Cost for Partial Losses, provides for the full cost of a functional repair without deduction for depreciation.",
  },
};

const yourBelongingsSettlementTypeTooltip: Record<
  SettlementOption,
  PartialScreenWithCoveragesRecord
> = {
  [SettlementOption.Acv]: {
    [ScreenWithCoverages.PlanDetails]:
      "Actual Cash Value (ACV) refers to the cost to repair or replace your personal items minus depreciation. Depreciation is the reduction in value resulting from aging and deterioration. As an example, a 15 year old refrigerator is not as valuable as a 5 year old refrigerator.",
  },
  [SettlementOption.Rc]: {
    [ScreenWithCoverages.PlanDetails]:
      "Replacement Cost (RC) refers to the cost to repair or replace your personal items. No depreciation occurs.",
  },
  [SettlementOption.Erc]: {},
  [SettlementOption.Frc]: {},
};

const otherStructuresSettlementTypeTooltip: Record<
  SettlementOption,
  PartialScreenWithCoveragesRecord
> = {
  [SettlementOption.Acv]: {
    [ScreenWithCoverages.PlanDetails]:
      "Actual Cash Value (ACV) refers to the cost to repair or replace your structure minus depreciation. Depreciation is the reduction in value resulting from aging and deterioration. As an example, a 10 year old fence is not as valuable as a new fence.",
  },
  [SettlementOption.Rc]: {
    [ScreenWithCoverages.PlanDetails]:
      "Replacement Cost (RC) refers to the cost to repair or replace the structure. No depreciation occurs.",
  },
  [SettlementOption.Erc]: {
    [ScreenWithCoverages.PlanDetails]:
      "Extended Replacement Cost (ERC) works similar to Replacement Cost. However, if a total loss occurs ERC provides up to an additional 20% in coverage if the structure costs more to replace than the purchased dwelling limit.",
  },
  [SettlementOption.Frc]: {
    [ScreenWithCoverages.PlanDetails]:
      "Full Repair Cost, sometimes referred to as Replacement Cost for Partial Losses, provides for the full cost of a functional repair without deduction for depreciation.",
  },
};

const getHomeCoverageSettlementTypeTooltip = (
  mineSubsidenceOption: SettlementOption,
  screen: ScreenWithCoverages
): string | undefined =>
  homeCoverageSettlementTypeTooltip[mineSubsidenceOption][screen];

const getYourBelongingsSettlementTypeTooltip = (
  mineSubsidenceOption: SettlementOption,
  screen: ScreenWithCoverages
): string | undefined =>
  yourBelongingsSettlementTypeTooltip[mineSubsidenceOption][screen];

const getOtherStructuresSettlementTypeTooltip = (
  mineSubsidenceOption: SettlementOption,
  screen: ScreenWithCoverages
): string | undefined =>
  otherStructuresSettlementTypeTooltip[mineSubsidenceOption][screen];

export {
  SettlementOption,
  getHomeCoverageSettlementTypeTooltip,
  getYourBelongingsSettlementTypeTooltip,
  getOtherStructuresSettlementTypeTooltip,
};
